import {
  StakeholderQuestions_StakeFragment,
  StakeholderQuestions_SurveyFragment,
  SurveyQuestionType,
} from '@/graphql/generated';
import { SimpleMaterialityQuestionsArray } from '../../../project/publications/simpleMateriality/SimpleMaterialityQuestionsArray';
import { DoubleMaterialitySeverityArrays } from '../../../project/publications/doubleMateriality/DoubleMaterialitySeverityArrays';
import { ReactNode } from 'react';

export function ConsolidatedMaterialityArrays({
  stake,
  surveys,
}: {
  stake: StakeholderQuestions_StakeFragment;
  surveys: StakeholderQuestions_SurveyFragment[];
}) {
  // Materiality can be:
  // - simple (SurveyQuestionType.Matrix)
  // - double (SurveyQuestionType.StakeDoubleMateriality)
  //   - financial
  //   - impact
  // - double for custom question types (for example: SurveyQuestionType.UtopiesStakeDoubleMateriality)
  //   - financial
  //   - impact

  const materialityArrays: ReactNode[] = [];

  const simpleMaterialityQuestionIds = surveys
    .flatMap((survey) => survey.questions)
    .flatMap((question) =>
      question?.type === SurveyQuestionType.Group
        ? question?.children
        : [question],
    )
    .filter((question) => question?.type === SurveyQuestionType.Matrix)
    .map((question) => question?.id || '');

  if (simpleMaterialityQuestionIds.length > 0) {
    materialityArrays.push(
      <SimpleMaterialityQuestionsArray
        stake={stake}
        questionIds={simpleMaterialityQuestionIds}
      />,
    );
  }

  const doubleMaterialityQuestionIds = surveys
    .flatMap((survey) => survey.questions)
    .filter(
      (question) =>
        question &&
        [
          SurveyQuestionType.StakeDoubleMateriality,
          SurveyQuestionType.UtopiesStakeDoubleMateriality,
        ].includes(question.type),
    )
    .map((question) => question?.id || '');

  if (doubleMaterialityQuestionIds.length > 0) {
    materialityArrays.push(
      <DoubleMaterialitySeverityArrays
        stakes={[stake]}
        questionIds={doubleMaterialityQuestionIds}
      />,
    );
  }

  return <div className="space-y-4">{materialityArrays}</div>;
}
